import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule, DatePipe } from '@angular/common';
import { SwiperModule } from 'swiper/angular';
import { CountToModule } from 'angular-count-to';
import { NgxMasonryModule } from 'ngx-masonry';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng5SliderModule } from 'ng5-slider';
import { GalleryModule } from 'ng-gallery';
import { LightboxModule } from 'ng-gallery/lightbox';

import { LandingComponent } from './pages/landing/landing.component';
import { HomeComponent } from './pages/home/home.component';
import { MosaicComponent } from './pages/mosaic/mosaic.component';
import { SpinnerComponent } from './pages/spinner/spinner.component';
import { WheelComponent } from './pages/wheel/wheel.component';
import { SliderComponent } from './pages/slider/slider.component';
import { LoginComponent } from './pages/login/login.component';
import { JoinComponent } from './pages/join/join.component';
import { ParticipateComponent } from './pages/participate/participate.component';
import { SectionAboutComponent } from './components/section-about/section-about.component';
import { SectionBlogComponent } from './components/section-blog/section-blog.component';
import { SectionBookingComponent } from './components/section-booking/section-booking.component';
import { SectionContactComponent } from './components/section-contact/section-contact.component';
import { SectionCopyrightComponent } from './components/section-copyright/section-copyright.component';
import { SectionCounterComponent } from './components/section-counter/section-counter.component';
import { SectionGalleryComponent } from './components/section-gallery/section-gallery.component';
import { SectionHeaderComponent } from './components/section-header/section-header.component';
import { SectionNavComponent } from './components/section-nav/section-nav.component';
import { SectionPricingComponent } from './components/section-pricing/section-pricing.component';
import { SectionScheduleComponent } from './components/section-schedule/section-schedule.component';
import { SectionSpeakerComponent } from './components/section-speaker/section-speaker.component';
import { SectionSponsorComponent } from './components/section-sponsor/section-sponsor.component';
import { SectionSubscribeComponent } from './components/section-subscribe/section-subscribe.component';
import { SectionTestimonialComponent } from './components/section-testimonial/section-testimonial.component';

@NgModule({
  declarations: [
    AppComponent,
    LandingComponent, 
    HomeComponent,
    MosaicComponent,
    SpinnerComponent,
    WheelComponent,
    SliderComponent,
    LoginComponent,
    JoinComponent,
    ParticipateComponent,
    SectionAboutComponent,
    SectionBlogComponent,
    SectionBookingComponent,
    SectionContactComponent,
    SectionCopyrightComponent,
    SectionCounterComponent,
    SectionGalleryComponent,
    SectionHeaderComponent,
    SectionNavComponent,
    SectionPricingComponent,
    SectionScheduleComponent,
    SectionSpeakerComponent,
    SectionSponsorComponent,
    SectionSubscribeComponent,
    SectionTestimonialComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    CarouselModule,
    SharedModule,
    NgbModule,
    CommonModule,
    CarouselModule,
    NgbModule,
    GalleryModule,
    LightboxModule,
    SharedModule,
    CountToModule,
    FormsModule,
    ReactiveFormsModule,
    Ng5SliderModule,
    NgxMasonryModule,
    SwiperModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }